'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCreatingThread = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCreatingThread = exports.isCreatingThread = function isCreatingThread(state) {
  return (0, _statusComparators.isStarted)((0, _getIn2.default)(['createThreadStatus'], state));
};